import React, { useState, useEffect } from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";

import { listAgents } from "../../services/agentIa";
import toastError from "../../errors/toastError";

// Selector de agente reutilizado por Entrenamiento y Documentación — todo
// lo que hace cada una de esas pantallas queda aislado al agente elegido
// acá (sus propios documentos, su propio banco de respuestas).
const AgentIaSelector = ({ value, onChange }) => {
  const [agents, setAgents] = useState([]);

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        const data = await listAgents();
        setAgents(data);
        if (!value && data.length > 0) {
          onChange(data[0].id);
        }
      } catch (err) {
        toastError(err);
      }
    };
    fetchAgents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FormControl variant="outlined" size="small" style={{ minWidth: 240 }}>
      <InputLabel>Agente</InputLabel>
      <Select
        label="Agente"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
      >
        {agents.map((agent) => (
          <MenuItem key={agent.id} value={agent.id}>
            {agent.name}
            {agent.label ? ` — ${agent.label}` : ""}
          </MenuItem>
        ))}
        {agents.length === 0 && (
          <MenuItem value="" disabled>
            No hay agentes creados
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default AgentIaSelector;
